import { Controller } from 'stimulus'

const normalize = text => String(text || '').replace(/\r\n/g, '\n').trim()

export default class extends Controller {
  static targets = ['agent', 'pane', 'text', 'default', 'status', 'count', 'unsaved']

  connect() {
    this.saved = this.textTargets.map(text => normalize(text.value))
    this.refresh()
  }

  select(event) {
    const index = Number(event.currentTarget.dataset.index)

    this.agentTargets.forEach((agent, i) => agent.classList.toggle('is-active', i === index))
    this.paneTargets.forEach((pane, i) => { pane.hidden = i !== index })
    this.textTargets[index]?.focus()
  }

  reset(event) {
    const index = this.paneTargets.indexOf(event.currentTarget.closest('[data-target~="bo-prompts.pane"]'))
    if (index < 0) return

    this.textTargets[index].value = this.defaultText(index)
    this.refresh()
  }

  refresh() {
    let unsaved = false

    this.textTargets.forEach((text, index) => {
      const value     = normalize(text.value)
      const isDefault = value === '' || value === normalize(this.defaultText(index))
      const changed   = value !== this.saved[index]
      unsaved = unsaved || changed

      const status = this.statusTargets[index]
      status.textContent = (isDefault ? 'Par défaut' : 'Personnalisé') + (changed ? ' · modifié' : '')
      status.classList.toggle('is-custom', !isDefault)
      status.classList.toggle('is-changed', changed)

      const lines = value === '' ? 0 : value.split('\n').length
      this.countTargets[index].textContent = `${lines} ligne${lines > 1 ? 's' : ''} · ${value.length} caractère${value.length > 1 ? 's' : ''}`

      this.paneTargets[index].querySelector('.bo-prompts__reset').disabled = isDefault
    })

    if (this.hasUnsavedTarget) this.unsavedTarget.hidden = !unsaved
  }

  defaultText(index) {
    return this.defaultTargets[index]?.content.textContent || ''
  }
}
